// extracted by mini-css-extract-plugin
export default {"container":"InformationOverlay_container__jUjFw"};